import React from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import PropTypes from "prop-types"
import { t } from "i18next"
import InputRHF from "components/RHF/InputRHF"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { toast } from "react-toastify"
import { create_user_schema } from "helpers/validationSchema"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createEmployee } from "api/employeeApi"
import LoadingButton from "components/Common/LoadingButton"
import CheckboxRHF from "components/RHF/CheckboxRHF"

function CreateEmployeeModal({ isOpen, toggle, ...otherProps }) {
  const queryClient = useQueryClient()
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      user: {
        fullname: "",
        password: "",
        phone: "",
        email: "",
        username: "",
      },
      view_all: true,
    },
    resolver: yupResolver(create_user_schema),
  })
  const { mutate, isPending } = useMutation({
    mutationFn: createEmployee,
    onError: error => toast.error(error),
    onSuccess: () => {
      queryClient.invalidateQueries("employees")
      reset()
      toggle()
    },
  })

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} {...otherProps}>
      <ModalHeader toggle={toggle}>{t("create a new employee")}</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(mutate)} id="form_id">
          <InputRHF
            name="user.fullname"
            label={t("full name")}
            placeholder={t("enter full name")}
            control={control}
          />
          <InputRHF
            name="user.username"
            label={t("username")}
            placeholder={t("enter user name")}
            control={control}
          />
          <InputRHF
            name="user.password"
            label={t("password")}
            placeholder={t("enter password")}
            control={control}
          />
          <InputRHF
            name="user.email"
            label={t("email")}
            placeholder={t("example.dev@gmail.com")}
            control={control}
          />
          <InputRHF
            name="user.phone"
            label={t("phone")}
            placeholder={t("enter phone number")}
            control={control}
          />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button outline color="danger" onClick={toggle}>
          {t("cancel")}
        </Button>
        <LoadingButton
          isLoading={isPending}
          type="submit"
          color="primary"
          form="form_id"
        >
          {t("create")}
        </LoadingButton>
      </ModalFooter>
    </Modal>
  )
}
CreateEmployeeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
export default CreateEmployeeModal
